import React from 'react'
import { useIntl } from 'react-intl'
import type { StandingOrderItemType } from 'msp-integrations'
import * as S from '../../AccountOrders/AccountOrderDetail/OrderProductItemsList/OrderProductItemsList.styles'
import translations from '../../AccountOrders/AccountOrderDetail/OrderProductItemsList/OrderProductItemsList.constants'
import { StandingOrdersDetailsProductListItem } from './StandingOrdersDetailsProductListItem'

export const StandingOrdersDetailsProductList = ({
  productList
}: {
  productList: Array<StandingOrderItemType>
}) => {
  const { formatMessage } = useIntl()

  return (
    <>
      <div className={`font-Roboto text-14 ${S.Wrapper}`}>
        <div className={`font-bold ${S.TableViewHeadWrapper}`}>
          <div className={S.TableViewArticleName}>
            {formatMessage(translations.tableArticle)}
          </div>
          <div className={S.TableViewQuantity}>
            {formatMessage(translations.tableQuantity)}
          </div>
          <div className={S.TableViewUnitPrice}>
            {formatMessage(translations.tableUnitPrice)}
          </div>
          <div className={S.TableViewTotal}>
            {formatMessage(translations.tableTotal)}
          </div>
        </div>
        {productList.map((productItem, index) => (
          <StandingOrdersDetailsProductListItem
            productItem={productItem}
            currency={'EUR'}
            key={`order-product-${productItem.productId}-${index}`}
          />
        ))}
      </div>
    </>
  )
}
